// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"647":"fe5dea0f","895":"cc57685e"}[chunkId] + ".chunk.css";
};